// extracted by mini-css-extract-plugin
module.exports = {"elSection":"Section_elSection__19Oqt","warningModal":"Section_warningModal__r-GFw"};